import {
  createBrowserRouter,
  Navigate,
  RouterProvider,
} from "react-router-dom";
import Login from "../src/pages/login";
import Forgetpassword from "../src/pages/forgetpassword";
import Resetpassword from "./pages/resetpassword";
import Signup from "./pages/signup";
import Dashboard from "../src/dashboard/dashboard";
import Dashboardoutlet from "./dashboard/dashboardoutlet";
import MyDocView from "./dashboard/MyDocview/Mydocview";
import Fileupload from "./dashboard/dashboardMain/Search/fileupload";
import Fileclassification from "./dashboard/dashboardMain/Search/fileclassification";
import Clientlisting from "./Listing/clientListing";
import UseradminListing from "./Listing/useradminListing";
import GroupListing from "./Listing/groupListing";
import DoctypeListing from "./Listing/doctypeListing";
import PatternListing from "./Listing/patternListing";
import DocPatternListing from "./Listing/docpatternListing";
import Setting from "./dashboard/settings/setting";
import Verifycode from "./pages/verifycode";
import { isLoggedIn } from "./utils/utils";
import PendingApproval from "./pages/PendingApproval";
import LoaderModal from "./modals/loaderModal";
import Findings from "./Listing/findings";
import InactivityHandler from "./utils/inactivityHandler";

const PrivateRoute = (component) => {
  const loggedIn = isLoggedIn();
  console.log(loggedIn)
  return loggedIn ? component : <Navigate to="/login" />;
};
const PublicRoute = (component) => {
  console.log("hello")
  const loggedIn = isLoggedIn();
  return loggedIn ? <Navigate to="/dashboard" /> : component;
};

const AppLaout = () => {
  console.log('helo')
  return (
    <>
      <InactivityHandler />
      <RouterProvider router={appRouter} />
      <LoaderModal />
    </>
  );
};

const appRouter = createBrowserRouter([
  {
    path: "/",
    element: PrivateRoute(<Dashboard />),
    children: [
      {
        path: "dashboard",
        element: <Dashboardoutlet />,
        children: [
          // {
          //   path: "/dashboard",
          //   element: <DashboardMain />,
          // },
          {
            path: "fileUpload",
            element: <Fileupload />,
          },
          {
            path: "fileclassification",
            element: <Fileclassification />,
          },
        ],
      },

      // {
      //   path: "/findings",
      //   element: PrivateRoute(<Libraries />),
      // },
      {
        path: "/mydocview",
        element: PrivateRoute(<MyDocView />),
      },
      {
        path: "/settings",
        element: PrivateRoute(<Setting />),
      },
    ],
  },
  {
    path: "/login",
    element: PublicRoute(<Login />),
  },
  {
    path: "/pending-approval",
    element: <PendingApproval />,
  },
  {
    path: "/signup",
    element: PublicRoute(<Signup />),
  },
  {
    path: "/forgetpassword",
    element: PublicRoute(<Forgetpassword />),
  },
  {
    path: "/verifycode",
    element: PublicRoute(<Verifycode />),
  },
  {
    path: "/resetpassword",
    element: PublicRoute(<Resetpassword />),
  },
  {
    path: "/clientlistings",
    element: PrivateRoute(<Clientlisting />),
  },
  {
    path: "/userlisting",
    element: PrivateRoute(<UseradminListing />),
  },
  {
    path: "/finding",
    element: PrivateRoute(<Findings />),
  },
  {
    path: "/grouplisting",
    element: PrivateRoute(<GroupListing />),
  },
  {
    path: "/patternlisting",
    element: PrivateRoute(<PatternListing />),
  },
  {
    path: "/doctypelisting",
    element: PrivateRoute(<DoctypeListing />),
  },
  {
    path: "/docpatternlisting",
    element: PrivateRoute(<DocPatternListing />),
  },
]);
export default AppLaout;
